
<div class="page_container">
  <div class="static_steps">
    <div class="side_part" cdkDropList #selectedProductsList="cdkDropList" [cdkDropListConnectedTo]="[productsList]"
      [cdkDropListData]="selectedCatalogs" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"Catalogs.catalogs_assigned"|translate}}({{selectedCatalogs.length}})</span>
            <span class="descr_title">{{"Catalogs.drag_and_drop_catalogs_in_this_bloc"|translate}}</span>
          </div>
        </div>
        <div class="step no_height">
          <div class="step_title inline_title">
            <div>
              <span>
                {{"Catalogs.company_custom_discount"|translate}}
              </span>
            </div>
          </div>
          <div class="content">
            <div class="inline_block custom_block">
              <div class="field">
                <select name="" id="" disabled>
                  <option selected value="" selected>{{"Catalogs.price_descrease"|translate}}</option>
                </select>
              </div>
              <div class="field category_field" [formGroup]="form">
                <input type="number" formControlName="additional_discount" [value]="currentCustomDiscount" (input)="onGeneralDiscountChange($event)">
                <span class="indicate_input custom_indic">%</span>
              </div>
            </div>
          </div>
          <div class="confirm_alert" *ngIf="showAlert">
            <div class="confirm_message">
              <img src="assets/icones/warning.svg" alt="">
              <span>
                {{overrideCounter()}} {{"companies.catalogs_additional_discount" | translate}}
              </span>
            </div>
            <div class="confirm_btns">
                <button (click)="onSave()">{{"common.save" | translate | uppercase}}</button>
                <button (click)="onApplyAll()">{{"common.apply_all" | translate}}</button>
                <button class="cancel" (click)="onCancel()">{{"common.cancel" | translate}}</button>
            </div>
          </div>
        </div>
        <div class="inside_content listing_table_container">
          <table class="listing_table">
            <thead class="header_stiky">
              <tr class="head_table head_table_2">
                <th>{{"common.title"|translate}}</th>
                <th>{{"common.wholesale"|translate}} <br> {{"Catalogs.discount"|translate}}</th>
                <th>{{"Catalogs.additional"|translate}} <br> {{"Catalogs.discount"|translate}}</th>
                <th>{{"quotations_and_orders.product"|translate}}</th>
                <th>{{"common.location"|translate}}</th>
                <th>{{"common.remove"|translate}}</th>
              </tr>
            </thead>
            <tbody class="scrollable-body">
              <tr *ngFor="let catalog of selectedCatalogs; let i = index; trackBy: trackByFn"
                class="body_table body_table_2 hover_tr" cdkDrag>
                <td class="td_block">
                  <span class="bold_span">{{ catalog.name }}</span><br>
                </td>
                <td class="td_actions">
                  <span class="bold_span">{{catalog.general_discount}}%</span>
                </td>
                <td>
                  <div class="last_td">
                    <input class="input_table" [value]="catalog.additional_discount" type="number"
                      (input)="onAdditionalDiscountChange($event, i)">
                    <span class="indicate_input custom_indic">%</span>
                  </div>
                </td>
                <td>{{catalog.nbr_products}}</td>
                <td>{{catalog.nbr_locations}}</td>
                <td>
                  <button (click)="removeCatalog(catalog)">
                    <img src="../../../../../assets/icones/remove_circle.svg" alt="">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="side_part" cdkDropList #productsList="cdkDropList" [cdkDropListConnectedTo]="[selectedProductsList]"
      [cdkDropListData]="catalogs" (cdkDropListDropped)="drop($event)">
      <div class="step">
        <div class="step_title inline_title">
          <div>
            <span>{{"Catalogs.all_catalog"|translate}} ({{catalogs.length}})</span>
            <span class="descr_title">
              </span>
          </div>
          <div class="field">
            <ui-form-field
              class="input"
              type="text"
              [prefixIcon]="'search'"
              [placeholder]="'Catalogs.search_catalogs' | translate"
              [formControl]="search"
            ></ui-form-field>
          </div>
        </div>
        <div class="inside_content listing_table_container">
          <table class="listing_table">
            <thead class="header_stiky">
              <tr class="head_table">
                <th>{{"common.title"|translate}}</th>
                <th>{{"common.wholesale"|translate}} <br> {{"Catalogs.discount"|translate}}</th>
                <th>{{"quotations_and_orders.product"|translate}}</th>
                <th>{{"common.location"|translate}}</th>
                <th>{{"common.add"|translate}}</th>
              </tr>
            </thead>
            <tbody class="scrollable-body">
              <tr *ngFor="let catalog of catalogs; let i = index; trackBy: trackByFn" class="body_table hover_tr"
                cdkDrag>
                <td class="td_block">
                  <span class="bold_span">{{ catalog.name }}</span><br>
                </td>
                <td class="td_actions">
                  <span class="bold_span">{{catalog.general_discount}}%</span>
                </td>
                <td>{{catalog.nbr_products}}</td>
                <td>{{catalog.nbr_locations}}</td>
                <td>
                  <button (click)="addCatalog(catalog)">
                    <img src="assets/icones/black-add-icon.svg" alt="">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="submet_btns">
    <button class="save_btn_pop_up cancel_btn_pop_up" (click)="cancel()">{{"common.cancel"|translate}}</button>
    <button class="save_btn_pop_up blue_btn" (click)="save()">
      <span>{{"Catalogs.insert_catalogs"|translate}}</span>
      <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
    </button>
  </div>
</div>
